@if (length) {
  <span [@inOutAnimation]>{{ position }} {{ "ItemCounter.Of" | translate }} {{ length }}</span>
}
<mat-progress-bar mode="determinate" [value]="(position / length * 100)"></mat-progress-bar>